import { render, staticRenderFns } from "./addHonor.vue?vue&type=template&id=2cd20152&scoped=true"
import script from "./addHonor.vue?vue&type=script&lang=js"
export * from "./addHonor.vue?vue&type=script&lang=js"
import style0 from "./addHonor.vue?vue&type=style&index=0&id=2cd20152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd20152",
  null
  
)

export default component.exports